import { Component, OnInit } from '@angular/core';
import {Input} from "@angular/core";
import {ChangeDetectorRef} from "@angular/core";
import {PopoverController} from "@ionic/angular";
import {ViewService} from "src/app/services/common/view.service";
import {ModalController} from "@ionic/angular";
import {TranslateService} from "@ngx-translate/core";

@Component({
  selector: 'app-report-settings',
  templateUrl: './report-settings.page.html',
  styleUrls: ['./report-settings.page.scss'],
})
export class ReportSettingsPage implements OnInit {

  @Input() opts: any = {};
  @Input() type: string;


  changed: boolean = false;

  closeAction: any = () => {this.dismiss()};
  lang: any;

  constructor(
    private cd: ChangeDetectorRef,
    private popoverCtrl: PopoverController,
    private modalCtrl: ModalController,
    public view: ViewService,
    private translate: TranslateService,

  ) { }

  ngOnInit() {
  }

  async ionViewDidEnter() {
    this.translate.get('ROUTES_HISTORY').subscribe((lang: any) => {
      this.lang = lang;
    });

    ViewService.updateView.next(undefined)
  }


  changeVal(option: any, event: any){
    switch (option){
      case 'stopTime':
        if(this.opts.report_stopTime !== event.value){

        }
        break;
      case 'tresholdStart':
        if(this.opts.report_tresholdStart !== event.value){

        }
        break;
    }
  }

  /**
   * Step discreti per la soglia tempo di sosta (in secondi):
   *  - 0..120 sec ogni 1 sec
   *  - 3, 4, 5 min            → 180, 240, 300
   *  - 10, 15, 20, 25, 30 min → 600, 900, 1200, 1500, 1800
   */
  readonly stopTimeSnaps: number[] = (() => {
    const arr: number[] = [];
    for(let s = 0; s <= 120; s++) arr.push(s);
    arr.push(180, 240, 300, 600, 900, 1200, 1500, 1800);
    return arr;
  })();

  /**
   * Forma estesa per la label sotto al titolo: "30 sec", "5 min", "5 min 30 sec".
   */
  private formatStopTime(value: number): string {
    const v = Math.max(0, Math.round(Number(value) || 0));
    if(v < 60) return `${v} sec`;
    const m = Math.floor(v / 60);
    const s = v % 60;
    return s === 0 ? `${m} min` : `${m} min ${s} sec`;
  }

  /**
   * Forma compatta per il pin sopra il knob: "30s", "5m", "5m30s".
   * Più corta così non va a capo nel pin tondo.
   */
  private formatStopTimeCompact(value: number): string {
    const v = Math.max(0, Math.round(Number(value) || 0));
    if(v < 60) return `${v}s`;
    const m = Math.floor(v / 60);
    const s = v % 60;
    return s === 0 ? `${m}m` : `${m}m${s}s`;
  }

  get stopTimeLabel(): string {
    return this.formatStopTime(this.opts?.report_stopTime ?? 0);
  }

  /** Indice nell'array snap che meglio approssima il valore corrente in opts. */
  get stopTimeIndex(): number {
    const cur = Number(this.opts?.report_stopTime ?? 0);
    let bestI = 0;
    let bestDiff = Number.POSITIVE_INFINITY;
    for(let i = 0; i < this.stopTimeSnaps.length; i++){
      const d = Math.abs(this.stopTimeSnaps[i] - cur);
      if(d < bestDiff){ bestDiff = d; bestI = i; }
    }
    return bestI;
  }

  onStopTimeChange(event: any) {
    const idx = Number(event?.detail?.value);
    if(Number.isNaN(idx)) return;
    const safeIdx = Math.max(0, Math.min(this.stopTimeSnaps.length - 1, Math.round(idx)));
    const seconds = this.stopTimeSnaps[safeIdx];
    if(this.opts.report_stopTime !== seconds){
      this.opts.report_stopTime = seconds;
    }
    this.changeVal('stopTime', { value: seconds });
  }

  // Arrow function così mantiene il binding quando passata via [pinFormatter].
  // Mostra il valore in forma compatta dentro il pin (niente wrap del testo).
  stopTimePinFormatter = (value: number): string => {
    const idx = Math.max(0, Math.min(this.stopTimeSnaps.length - 1, Math.round(Number(value) || 0)));
    return this.formatStopTimeCompact(this.stopTimeSnaps[idx]);
  };

  dismiss(){
    this.modalCtrl.dismiss()
  }

  save(){
    this.modalCtrl.dismiss({opts: this.opts})

  }

}
